<template>
<b-modal ref="modal"
         :hide-header-close="hideHeaderClose"
         :no-close-on-backdrop="noCloseOnBackdrop"
         :no-close-on-esc="noCloseOnEsc"
         :title="title"
         :size="size">

	<div class="d-block text-center">
		<slot name="modal-body">
		</slot>
	</div>

	<div slot="modal-footer">
		<slot name="modal-footer">
		</slot>
	</div>
</b-modal>
</template>

<script>
export default {
	name: 'base-dialog-modal',
	data: () => ({}),
	props: {
		title: {
			type: String,
			required: true
		},
		hideHeaderClose: {
			type: Boolean,
			default: false
		},
		noCloseOnBackdrop: {
			type: Boolean,
			default: false
		},
		noCloseOnEsc: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'md'
		}
	},
	methods: {
		/**
		 * Show the modal
		 */
		show() {
			this.$refs.modal.show();
		},

		/**
		 * Hide the modal
		 */
		hide() {
			this.$refs.modal.hide();
		},

		hideEvent(event) {
			this.$emit('hide', event);
		}
	}
}
</script>

<style lang="scss">
.modal-footer {
    display: block !important;
}
</style>



// WEBPACK FOOTER //
// BaseDialogModal.vue?749e66e3